import { RDEqipCurrentPractices, TraitId } from '@cibo/core'
import { useUpdateMultipleFields } from '@cibo/landmanager'
import { ResourceDetailFeatureTaskEditorProps } from '@cibo/ui'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { MultiselectCheckboxFieldTable } from '../MultiselectCheckboxFieldTable'

const SOURCES = [
  'eqipPracticeChoiceAgroforestry',
  'eqipPracticeChoiceEngineeringLandErosionStructures',
  'eqipPracticeChoiceEngineeringWaterControlStructures',
  'eqipPracticeChoiceSoil',
  'eqipPracticeChoiceWildlife',
] as TraitId[]

export const RDEqipCurrentPracticesTaskEditor = ({
  userRole,
  ownerName,
  resourceIds,
  ...props
}: ResourceDetailFeatureTaskEditorProps<RDEqipCurrentPractices>) => {
  const { t } = useTranslation('@cibo/programs/RDEqipCurrentPracticesTaskEditor')
  const updateFields = useUpdateMultipleFields()

  return (
    <Stack spacing={3}>
      <Typography>
        {t('question', { context: userRole, ownerName, count: resourceIds.length })}
      </Typography>
      <MultiselectCheckboxFieldTable
        traitId="eqipCurrentPractices"
        sources={SOURCES}
        handleChange={updateFields.mutateAsync}
        {...props}
      />
    </Stack>
  )
}
